export const ROLE_LABELS = {
  admin: 'Администратор',
  manager: 'Менеджер',
  procurement: 'Закуп',
  production: 'Производство',
  assembly: 'Сборка',
  testing: 'Испытания',
  packaging: 'Упаковка',
  viewer: 'Наблюдатель',
};

export const STAGE_GROUPS = {
  procurement: { label: 'Закуп'},
  production: { label: 'Производство-КД' },
  assembly: { label: 'Сборка'},
  testing: { label: 'Испытания'},
  packaging: { label: 'Упаковка'},
  completed: { label: 'Завершено'},
  cancelled: { label: 'Отменено'},
  incorrect: { label: 'Некорректно'},
};

export function canEditStageGroup(role, stageGroup) {
  if (!role || role === 'viewer') return false;
  if (role === 'admin' || role === 'manager') return true;
  return role === stageGroup;
}

export function canManageProducts(role) {
  return role === 'admin' || role === 'manager';
}

export function canManageContracts(role) {
  return canManageProducts(role);
}

export function canManageRemnants(role) {
  return ['admin', 'manager', 'production', 'procurement', 'assembly', 'testing', 'packaging'].includes(role);
}

export function canUploadFiles(role) {
  return ['admin', 'manager', 'production', 'procurement', 'assembly', 'testing', 'packaging'].includes(role);
}

export function getVisibleMenuItems(role) {
  const all = true;
  if (role === 'viewer' || !role) return { all: true, edit: false };
  if (['admin', 'manager'].includes(role)) return { all: true, edit: true };
  return { all: true, edit: canEditStageGroup(role, role) };
}

export const GROUP_ORDER = ['procurement', 'production', 'assembly', 'testing', 'packaging', 'completed', 'cancelled', 'incorrect'];

export function getGroupProgress(stages) {
  if (!stages?.length) return 0;
  const done = stages.filter((s) => s.status === 'completed').length;
  return Math.round((done / stages.length) * 100);
}

export function isGroupUnlocked(grouped, groupKey) {
  if (['completed', 'cancelled', 'incorrect'].includes(groupKey)) return true;
  const index = GROUP_ORDER.indexOf(groupKey);
  if (index <= 0) return true;
  const prevGroup = GROUP_ORDER[index - 1];
  const prevStages = grouped[prevGroup] || [];
  return prevStages.every(s => s.status === 'completed');
}

export function getActiveGroup(contract) {
  if (!contract?.details) return GROUP_ORDER[0];
  const sorted = [...contract.details].sort(
    (a, b) => GROUP_ORDER.indexOf(a.stage_group) - GROUP_ORDER.indexOf(b.stage_group)
  );
  const nonFinal = sorted.find(d => !['completed', 'cancelled', 'incorrect'].includes(d.stage_group));
  return nonFinal?.stage_group || 'completed';
}

export function sortByPriority(contracts) {
  return [...contracts].sort((a, b) => {
    if (a.is_overdue && !b.is_overdue) return -1;
    if (!a.is_overdue && b.is_overdue) return 1;
    const da = a.nearest_deadline || a.end_date || '9999';
    const db = b.nearest_deadline || b.end_date || '9999';
    return da.localeCompare(db);
  });
}
